// Deterministic local categorisation. No remote API, no guesswork, no mutation.
export const normalizeMerchant = value => String(value || '').normalize('NFKC').toLowerCase()
  .replace(/[^a-z0-9\s]/g,' ').replace(/\s+/g,' ').trim();
export function matchCategoryRule({payee='',notes='',type='expense'}, rules=[], categories=[]) {
  const merchant=normalizeMerchant(payee);
  if(!merchant) return null;
  const sorted=[...rules].filter(r=>r && r.enabled!==false && r.type===type)
    .sort((a,b)=>(Number(b.priority)||0)-(Number(a.priority)||0));
  for(const rule of sorted){
    const pattern=normalizeMerchant(rule.pattern);
    if(!pattern || !['contains','startsWith','exact'].includes(rule.match)) continue;
    const matched=rule.match==='exact'?merchant===pattern:
      rule.match==='startsWith'?merchant.startsWith(pattern):merchant.includes(pattern);
    if(matched && categories.some(c=>c.type===type && c.name===rule.category))
      return {category:rule.category,ruleId:rule.id,pattern:rule.pattern};
  }
  return null;
}
export function validCategoryRule(rule,categories,existing=[]){
  const pattern=normalizeMerchant(rule.pattern);
  if(pattern.length<2)throw new Error('Enter at least two merchant characters.');
  if(!['expense','income'].includes(rule.type))throw new Error('Choose Income or Expense.');
  if(!['contains','startsWith','exact'].includes(rule.match))throw new Error('Choose a supported match type.');
  if(!categories.some(c=>c.name===rule.category&&c.type===rule.type))throw new Error('Choose an existing category of the same type.');
  if(existing.some(r=>r.id!==rule.id&&r.type===rule.type&&r.match===rule.match&&normalizeMerchant(r.pattern)===pattern))
    throw new Error('This merchant rule already exists.');
  return {...rule,pattern,priority:Number(rule.priority)||0,enabled:rule.enabled!==false};
}